<template>
  <div>
    <h5>
      Q{{item.order}}
    </h5>
    <div class="boardBg surveyBox adminSurbeyBox">
        <div class="surveyBoxTop flex flexAlignS">
          <h4>
            단답형
          </h4>
          <button @click="$emit('onClickDeleteItem', item.order-1)"></button>
        </div>
        
        <b-form-checkbox class="termCheckBox" v-model="essential">필수항목</b-form-checkbox>
        

      <div class="surveyBoxInput flex flexAlignS">
        <label for="">질문</label>
        <input v-model="item.question" maxlength="170"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Short',
  props:{
    item: null
  },
  computed:{
    essential:{
      get(){
        if(this.item.essential === 'Y') return true
        else return false
      },
      set(value){
        if(value) this.item.essential = 'Y'
        else this.item.essential = 'N'
      }
    }
  },
}
</script>